// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f8c141","mobile":"_ae1b2a0","scroll":"_6a4f93d","header":"_18184ab","button":"_0fd2b6f","right":"_2b433ad","gameList":"_2134723"};